window.jQuery = window.$ = require('jquery');

// loading bootstarp js
require('bootstrap/js/collapse.js');
require('bootstrap/js/dropdown.js');
require('bootstrap/js/transition.js');

// loading jquery Ui

require('jquery-ui/ui/core.js');
require('jquery-ui/ui/widgets/autocomplete.js');
require('jquery-ui/ui/widgets/progressbar.js');

require('jquery-ui/themes/base/base.css');
require('jquery-ui/themes/base/core.css');
require('jquery-ui/themes/base/progressbar.css');
require('jquery-ui/themes/base/autocomplete.css');

// Loading Styles
require('../less/common.less');

window.i18n = require(`./json_locale/${LANGUAGE_CODE}/djangojs.json`);
require('./vendor/django.i18n.js');

require('./common.js');
require('./search.js');

// require('../../pro/assets/components/Upsell/Tracker.js');

// require('../../pro/assets/components/Upsell/utils').loadReactComponentOnLegacyPage(
//   'print',
//   require('components/Modals/PrintOptionsModal').default,
// );
